import { Navigate, Route, Routes } from 'react-router';
import XoopsPathRedirect from '../common/XoopsPathRedirect';
import Config, { type MultiLang } from '../config';
import CosmoDb from '../cosmodb/CosmoDb';
import Credits from '../credits/Credits';
import Pico from '../pico/Pico';
import PubmedPdf from '../pubmedpdf/PubmedPdf';
import Xwords from '../xwords/Xwords';
import CustomBlock from './blocks/CustomBlock';
import Footer from './Footer';
import Header from './Header';

interface Props {
    lang: MultiLang;
}

const TOP_URL = '/modules/htmldocs/IVBPF/Top/index.html';

const COSMODB_MODULES = [
    'newdb1',
    'newdb2',
    'newdb3',
    'newdb5',
    'newdb7',
    'newdb8',
    'newdb9',
    'newdb10',
    'newdb112',
    'newdb12',
    'newdb13',
];

const Page = (props: Props) => {
    const { lang } = props;
    return (
        <div id="page">
            <Header lang={lang} />
            <div id="main">
                <Routes>
                    {[...COSMODB_MODULES, 'noneLectClass'].map((dirname) => (
                        <Route
                            key={dirname}
                            path={`/modules/${dirname}/*`}
                            element={<CustomBlock lang={lang} modulepath={`/modules/${dirname}`} />}
                        />
                    ))}
                    <Route path="*" element={null} />
                </Routes>
                <div className="mainContent">
                    <Routes>
                        <Route index element={<Navigate to={TOP_URL} replace />} />
                        <Route path="/modules/htmldocs/index.html" element={<Navigate to={TOP_URL} replace />} />
                        <Route path="/modules/htmldocs/IVBPF/index.html" element={<Navigate to={TOP_URL} replace />} />
                        {Config.PICO_MODULES.map((dirname) => (
                            <Route
                                key={dirname}
                                path={`/modules/${dirname}/*`}
                                element={<Pico lang={lang} dirname={dirname} />}
                            />
                        ))}
                        {COSMODB_MODULES.map((dirname) => (
                            <Route
                                key={dirname}
                                path={`/modules/${dirname}/*`}
                                element={<CosmoDb lang={lang} dirname={dirname} />}
                            />
                        ))}
                        <Route path="/modules/credits/*" element={<Credits lang={lang} />} />
                        <Route path="/modules/PubMedPDF/*" element={<PubmedPdf lang={lang} />} />
                        <Route path="/modules/xwords/*" element={<Xwords lang={lang} />} />
                        <Route
                            path="/modules/noneLectClass/*"
                            element={
                                <div>
                                    神生研教員研修:{' '}
                                    <a href="http://www.brain.rcast.u-tokyo.ac.jp/others/2010-jinseiken/100131-jinseiken-text.pdf">
                                        100131-jinseiken-text.pdf
                                    </a>
                                </div>
                            }
                        />
                        <Route path="*" element={<XoopsPathRedirect lang={lang} />} />
                    </Routes>
                </div>
            </div>
            <Footer lang={lang} />
        </div>
    );
};

export default Page;
